"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _makeMethod = require("@/api/goods/makeMethod");
var _goods = require("@/api/goods/goods");
var _sortablejs = require("sortablejs");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'makeMethodManage',
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      dataList: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        typeId: null
      },
      types: [],
      editEquityVisible: false,
      editForm: {
        id: null,
        methodName: '',
        methodNameEn: '',
        sort: 0
      }
    };
  },
  created: function created() {
    this.getList();
    this.getTypes();
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 272, "px");
    }
  },
  methods: {
    handleOpenEstimateInfo: function handleOpenEstimateInfo(row) {
      this.$emit('open-makeMethodEstimateInfo', {
        id: row
      });
    },
    handleModifyFlag: function handleModifyFlag(id, modifyFlag) {
      var _this = this;
      (0, _makeMethod.update)({
        id: id,
        modifyFlag: modifyFlag
      }).then(function (res) {
        if (res.code === 0) {
          _this.$message.success('操作成功');
          _this.getList();
        }
      });
    },
    handleSyncMakeMethod: function handleSyncMakeMethod() {
      var _this2 = this;
      this.$confirm('确认同步做法数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _goods.syncMakeMethod)().then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this2.$message.success('同步成功');
            _this2.getList();
          } else {
            _this2.$message.error(res.message || '同步失败');
          }
        }).catch(function () {
          _this2.$message.error('同步失败');
        });
      }).catch(function () {});
    },
    getTypes: function getTypes() {
      var _this3 = this;
      (0, _makeMethod.queryTypeList)({
        page: 1,
        limit: 1000
      }).then(function (res) {
        if (res) {
          _this3.types = res.records;
        }
      });
    },
    getList: function getList() {
      var _this4 = this;
      this.listLoading = true;
      (0, _makeMethod.queryList)(this.listQuery).then(function (response) {
        if (response) {
          _this4.dataList = response.records;
          _this4.total = response.total;
        }
        setTimeout(function () {
          _this4.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this4.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    openEquitiesDialog: function openEquitiesDialog(row) {
      var _this5 = this;
      (0, _makeMethod.getById)(row.id).then(function (res) {
        _this5.editForm = res.data;
      });
      this.editEquityVisible = true;
    },
    equitiesDialogClose: function equitiesDialogClose() {
      this.$refs.editFormRef.resetFields();
    },
    saveEquity: function saveEquity() {
      var _this6 = this;
      this.$refs.editFormRef.validate(function (valid) {
        if (valid) {
          (0, _makeMethod.update)(_this6.editForm).then(function () {
            _this6.$message.success('编辑成功');
            _this6.editEquityVisible = false;
            _this6.getList();
          }).catch(function () {
            _this6.$message.error('保存失败');
          });
        }
      });
    }
  }
};